<template>
  <div>
    <TheHeader />
    <section class="main">
      <div class="container pt-5">
        <div class="row">
          <div class="col">
            <h3>{{ $store.state.produto.nome }}</h3>
            <hr />
          </div>
        </div>
       
        <div class="row mt-4">
          <transition mode="out-in">
            <div class="col-12" v-if="cursos.length">
              <div class="row">
                <ul
                  class="nav nav-pills cursos-tab mb-3 ml-2"
                  id="pills-tab"
                  role="tablist"
                >
                  <li class="nav-item">
                    <router-link
                      tag="a"
                      :to="{ name: 'meuscursos' }"
                      :active="$route.name == 'meuscursos'"
                      class="nav-link"
                      id="pills-profile-tab"
                      data-toggle="pill"
                      href="#pills-profile"
                      role="tab"
                      aria-controls="pills-profile"
                      aria-selected="false"
                      @click="cursosList = 0"
                      >Meus Cursos</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link
                      tag="a"
                      :to="{ name: 'faturasEad' }"
                      :active="$route.name == 'faturasEad'"
                      class="nav-link"
                      id="pills-home-tab"
                      data-toggle="pill"
                      href="#pills-faturas"
                      role="tab"
                      aria-controls="pills-faturas"
                      aria-selected="false"
                      @click="cursosList = 1"
                      >Histórico de Compras</router-link
                    >
                  </li>
                </ul>
                <hr />
              </div>
              <div class="row">
                <transition mode="out-in">
                  <router-view></router-view>
                </transition>
              </div>
            </div>
            <div class="col-12" v-else>
              <loading />
            </div>
          </transition>
        </div>
      </div>
    </section>
    <TheFooter />
  </div>
</template>
<script>
import { filterByValue } from "../../helpers.js";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
export default {
  name: "CdlEad",
  components: {
    TheHeader,
    TheFooter,
  },
  data() {
    return {
      cart: [],
      cursosList: 0,
      token: process.env.VUE_APP_IMAGE_TOKEN,
      cursos: "",
      faturas: [],
      buscaFiltrada: "",
      produto: {
        nome: "ONLINE Cursos Para o Varejo CDL/BH",
        id: "Varejo CDL/BH",
      },
      list: [
        {
          title: "Home",
          link: "/",
        },
        {
          title: "ONLINE Cursos Para o Varejo CDL/BH",
          link: "",
        },
      ],
    };
  },
  methods: {
    buscarProdutos(event) {
      this.buscaFiltrada = filterByValue(this.cursos, event.target.value);
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$http
      .get("/api/Ead/ListarCursosEAD")
      .then((response) => {
        var value = response.data.courses;
        value.map((e) => {
          e["qte"] = 0;
        });
        this.cursos = value;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>

<style lang="scss" scoped>
.cursos-tab {
  li {
    a {
      height: 40px;
      border-radius: 0;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      color: black;
      background: white;
      margin: 0.5rem;
      transition: all 0.2s ease-in-out;
    }
    a.active {
      background: #05428e;
      height: 40px;
      border-radius: 0;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
    }
  }
}

</style>
